












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import { ReadyHook } from 'vue-asyncready'
import { Hooper, Slide } from 'hooper'
import { requiredIf, sameAs } from 'vuelidate/lib/validators'
import moment from 'moment'

import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import SearchQuery from '@vue-storefront/core/lib/search/searchQuery'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'
import { isServer } from '@vue-storefront/core/helpers'
import config from 'config'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'

import {
  STRAP_SIZE_KEY,
  BUCKLE_KEY,
  getProductPrice,
  getWatchClinicDates
} from '../utilities'
import Breadcrumb from '../components/Breadcrumb.vue'
import StickyProductBar from './StickyProductBar.vue'
import ProductHeaderItem from './ProductHeaderItem.vue'
import BaseSelect from './form/BaseSelect.vue'
import Modal from './utils/Modal.vue'
import WebShare from '../../../../core/modules/social-share/components/WebShare.vue'
import Overlay from '../components/utils/Overlay.vue'
import PdpEmailForm from './PdpEmailForm.vue'
import PdpAppointmentForm from './PdpAppointmentForm.vue'

import RelatedColors from './related-colors/RelatedColors.vue'

const WATCH_CLINIC = 'Watch Clinic'

export default Vue.extend({
  name: 'ProductHeader',
  components: {
    StickyProductBar,
    Hooper,
    Slide,
    ProductHeaderItem,
    BaseSelect,
    Modal,
    Breadcrumb,
    NoSSR,
    DatePicker: () => import('vuejs-datepicker'),
    ModalAvailiableForm: () => import('./ModalAvailiableForm.vue'),
    ModalIconsForm: () => import('./ModalIconsForm.vue'),
    ProductZoomGallery: () => import('./ProductZoomGallery.vue'),
    ProductZoomGalleryButton: () => import('./ProductZoomGalleryButton.vue'),
    WebShare,
    Overlay,
    PdpEmailForm,
    PdpAppointmentForm,
    RelatedColors
  },
  filters: {
    convertToCM: function(value) {
      if (!value) return ''
      return value / 10
    }
  },
  mixins: [ReadyHook],
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  data() {
    return {
      STRAP_SIZE_KEY,
      BUCKLE_KEY,
      simpleProducts: { [STRAP_SIZE_KEY]: [], [BUCKLE_KEY]: [] },
      breadcrumb: [],
      autoReady: false,
      currentSlide: 0,
      loadedSlides: [],
      firstOption: null,
      secondOption: null,
      quantity: null,
      tooltipCn: false,
      reassurance: null,
      isSticky: false,
      isBottom: false,
      i18n: null,
      hooperSettings: {
        initialSlide: 0,
        transition: 600,
        playSpeed: 10000,
        autoPlay: true,
        mouseDrag: true,
        shortDrag: true,
        touchDrag: true,
        keysControl: true,
        wheelControl: false,
        hoverPause: false,
        infiniteScroll: true
      },
      dialsSettings: {
        wheelControl: false,
        itemsToShow: 3,
        itemsToSlide: 3,
        vertical: true
      },
      loop: 0,
      availableModal: false,
      iconsModal: false,
      ecommerceActivated: undefined,
      strapSize: null,
      buckleType: null,
      strapPrice: 0,
      openWatches: false,
      straps: null,
      currentDials: 0,
      hasStrapSlider: true,
      selectedWatchClinicExperience: null,
      watchClinicAvailableDates: [],
      watchClinicDisabledDates: {},
      watchClinicAvailableTimes: [],
      watchClinicTimeSlots: {
        dates: [],
        availabilities: [],
        languages: {}
      },
      watchClinicExperiences: [],
      selectedEventTime: null,
      selectedEventDate: null,
      selectedMonth: {y: new Date().getFullYear(), m: new Date().getMonth()},
      breadCrumbItems: [],
      descriptionCollapsed: true,
      inquireOverlayVisible: false,
      appointmentVisible: false,
      productZoomGallery: true,
      productZoomGalleryOpen: false,
      productZoomGalleryIndex: 0,
    }
  },
  validations: {
    firstOption: {
      required: requiredIf(function() {
        this.item.product.attribute_set_name === WATCH_CLINIC
      }),
      set: v => v !== 0
    },
    quantity: {
      required: requiredIf(function() {
        this.item.product.attribute_set_name === WATCH_CLINIC
      }),
      set: v => v !== null
    },
    selectedWatchClinicExperience: {
      required: requiredIf(function() {
        this.item.product.attribute_set_name === WATCH_CLINIC
      }),
      set: v => v !== null
    },
    selectedEventDate: {
      required: requiredIf(function() {
        this.item.product.attribute_set_name === WATCH_CLINIC
      }),
      set: v => v !== null
    },
    selectedEventTime: {
      required: requiredIf(function() {
        this.item.product.attribute_set_name === WATCH_CLINIC
      }),
      set: v => v !== null
    }
  },
  computed: {
    ...mapGetters('cart', ['getCartItems']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('watch-memory', ['getWatch']),
    countryCode() {
      const { i18n } = currentStoreView();
      return i18n.defaultCountry;
    },
    callCenterNumber () {
      const { storeCode } = currentStoreView()
      return storeCode ? config.storeViews[storeCode].contactPhone : null
    },
    showRelatedColors() {
      return !this.straps && this.item.product.color_related_watches && this.item.product.color_related_watches.length;
    },
    showTryOn() {
      return this.siblingsComponents.filter(
        sibling => sibling.component === 'color_selector'
      ).length < 1
    },
    showHowToCta() {
      return this.siblingsComponents.filter(sibling => sibling.component === 'images_tab_accordion' && sibling.item.showCta).length > 0
    },
    isGlobalE() {
      const { is_global_e_store } = currentStoreView()
      return is_global_e_store
    },
    showStrapCompatibilityCta() {
      return this.siblingsComponents.filter(sibling => sibling.component === 'straps_compatible_watches_slider').length > 0
    },
    isWatchClinic() {
      return this.item.product.attribute_set_name === WATCH_CLINIC
    },
    isSimpleProduct() {
      return !(
        this.item &&
        this.item.product &&
        this.item.product.bundle_options &&
        this.item.product.bundle_options.length
      )
    },
    accountActivated() {
      const { account } = currentStoreView()
      return account !== false
    },
    sizingGuidePdf() {
      const { i18n } = currentStoreView()
      const { defaultLocale } = i18n
      const fileName =
        defaultLocale === 'en-ge'
          ? `sizing-guide-en-GE.pdf`
          : defaultLocale === 'fr-ge'
          ? `sizing-guide-fr-GE.pdf`
          : `sizing-guide-${defaultLocale}.pdf`
      const path = `/assets/pdf/${fileName}`

      return path
    },
    noticeText() {
      return this.$t(
        'When you order your watch strap you will also be able to choose your buckle, which will be delivered pre-assembled. However, if you order a strap without a buckle, you will need to assemble the buckle yourself at home. To do this, we recommend using the *buckle tool, which will be offered as an optional extra during checkout. Watch the buckle tool tutorial to find out how. *Incorrect use of the buckle tool could damage your watch and ZENITH will not be held liable for any damage incurred. If you are uncertain or need assistance, take your watch to one of our boutiques, where our qualified staff will be happy to demonstrate the tool and change the buckle for you.'
      )
    },
    currentUser() {
      if (this.isLoggedIn) return this.$store.state.user.current
      else {
        return null
      }
    },
    manufacturerSku() {
      return (this.item && this.item.product && this.item.product.manufacturer_sku) ? this.item.product.manufacturer_sku : this.item.sku
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    storeCode() {
      const { storeCode } = currentStoreView()
      return storeCode
    },
    soldatStrap() {
      if (this.buckleType === null && this.item.soldat) {
        return {
          src: this.item.soldat.src,
          alt: this.item.soldat.alt ? this.item.soldat.alt : '',
          soldat: true,
          width: this.item.soldat.width,
          height: this.item.soldat.height
        }
      } else if (this.buckleType !== null && this.item.soldat) {
        let buckleSku = this.simpleProducts[BUCKLE_KEY][this.buckleType].sku
        return {
          src: this.getStrapWithBuckleImage(
            this.item,
            buckleSku,
            false
          ),
          alt: 'product_soldat',
          soldat: true,
          width: this.item.soldat.width,
          height: this.item.soldat.height
        }
      } else return null
    },
    soldat() {
      if (this.item.soldat) {
        return {
          src: this.item.soldat.src,
          alt: this.item.soldat.alt ? this.item.soldat.alt : '',
          soldat: !this.isWatchClinic,
          width: this.item.soldat.width,
          height: this.item.soldat.height
        }
      } else return null
    },
    pictures() {
      let pictures = []
      if (this.soldat) pictures.push(this.soldat)
      if (this.item.images.length > 0) {
        this.item.images.map(image => {
          let isConcatenation = null
          if (this.straps && this.straps.dials.length > 0) {
            isConcatenation = this.straps.dials.find(
              watch => watch.src === image.src
            )
          }
          if (!isConcatenation) {
            pictures.push({
              src: image.src,
              alt: image.alt ? image.alt : '',
              soldat: false,
              width: image.width,
              height: image.height
            })
          }
        })
      }
      return pictures
    },
    firstCustomOptions() {
      const customOptions = this.getCustomOptions()

      const opts = customOptions.map(({ values, option_id }) => {
        values = values || []
        return values.map(({ option_type_id, title }) => {
          return {
            option_id: option_id,
            option_value: option_type_id,
            title
          }
        })
      })

      return opts.length ? opts[0] : []
    },
    firstCustomOptionsOptions() {
      if (this.firstCustomOptions) {
        return this.firstCustomOptions.map(({ title }, index) => ({
          value: index,
          label:
            title === this.$t('Unsized')
              ? this.$t(title)
              : this.isWatchClinic
              ? this.$t(title.replace('&', ' '))
              : this.$t(title)
        }))
      }
      return null
    },
    firstCustomOption() {
      if (!this.firstOption) this.firstOption = 0
      if (this.firstCustomOptions && this.firstCustomOptionsOptions) {
        const item = this.firstCustomOptions.find(
          ({ value }, index) => index == this.firstOption
        )
        if (item) {
          return {
            option_id: item.option_id,
            option_value: item.option_value
          }
        }
      }
      return null
    },
    secondCustomOptions() {
      let options = []

      const customOptions = this.getCustomOptions()

      if (customOptions && customOptions[1]) {
        let { values, option_id: optionId } = customOptions[1]
        values = values || []
        options = values.map(({ option_type_id: optionTypeId, title }) => ({
          option_id: optionId,
          option_value: optionTypeId,
          title
        }))
      }
      return options
    },
    qtyOptions() {
      let options = []
      for (let i = 1; i <= this.maxExperiencesQty(); i++) {
        options.push({ value: i, label: i })
      }
      return options
    },
    secondCustomOptionsOptions() {
      return this.secondCustomOptions
        ? this.secondCustomOptions.map(({ title }, index) => ({
            value: index,
            label: title === this.$t('Unsized') ? this.$t(title) : title
          }))
        : null
    },
    secondCustomOption() {
      if (!this.secondOption) this.secondOption = 0
      if (this.secondCustomOptions && this.secondCustomOptionsOptions) {
        const item = this.secondCustomOptions.find(
          ({ value }, index) => index === parseInt(this.secondOption)
        )
        if (item) {
          return {
            option_id: item.option_id,
            option_value: item.option_value
          }
        } else {
          return null
        }
      }
      return null
    }
  },
  watch: {
    selectedWatchClinicExperience(a, b) {
      this.setWatchClinicAvailableDates()

      this.selectedEventDate = null
    },
    watchClinicAvailableDates() {
      const after2Years = moment()
        .add(1, 'days')
        .add(2, 'years')
        .format('YYYY-MM-DD')

      const enabledDates = []

      for (const date of this.watchClinicAvailableDates) {
        enabledDates.push(date.label)
      }

      const disabledDates = []

      for (
        let date = moment();
        date.isSameOrBefore(after2Years);
        date.add(1, 'days')
      ) {
        if (!enabledDates.includes(date.format('YYYY-MM-DD'))) {
          disabledDates.push(new Date(date.format('YYYY-MM-DD')))
        }
      }

      this.watchClinicDisabledDates = {
        to: new Date(moment().format('YYYY-MM-DD')),
        from: new Date(after2Years),
        dates: disabledDates
      }
    },
    buckleType() {
      let strapSize = null
      if (this.strapSize === null) {
        strapSize = 1
      } else {
        strapSize = this.strapSize
      }
      if (strapSize !== null) {
        const bucklePrice =
          this.simpleProducts &&
          this.simpleProducts[BUCKLE_KEY] &&
          this.simpleProducts[BUCKLE_KEY][this.buckleType]
            ? this.simpleProducts[BUCKLE_KEY][this.buckleType].price
            : 0
        const strapPrice =
          this.simpleProducts &&
          this.simpleProducts[STRAP_SIZE_KEY] &&
          this.simpleProducts[STRAP_SIZE_KEY][strapSize]
            ? this.simpleProducts[STRAP_SIZE_KEY][strapSize].price
            : 0
        this.strapPrice = bucklePrice + strapPrice
      }
    },
    strapSize() {
      let strapSize = null
      if (this.strapSize === null) {
        strapSize = 1
      } else {
        strapSize = this.strapSize
      }
      if (strapSize !== null) {
        const bucklePrice =
          this.simpleProducts &&
          this.simpleProducts[BUCKLE_KEY] &&
          this.simpleProducts[BUCKLE_KEY][this.buckleType]
            ? this.simpleProducts[BUCKLE_KEY][this.buckleType].price
            : 0
        const strapPrice =
          this.simpleProducts &&
          this.simpleProducts[STRAP_SIZE_KEY] &&
          this.simpleProducts[STRAP_SIZE_KEY][strapSize]
            ? this.simpleProducts[STRAP_SIZE_KEY][strapSize].price
            : 0
        this.strapPrice = bucklePrice + strapPrice
      }
    },
    selectedEventDate() {
      if (!this.selectedEventDate) {
        this.watchClinicAvailableTimes = []
        return
      }

      let date = this.formatSelectedDate()

      const selectedDate = this.watchClinicAvailableDates.find(
        ({ label }) => label === date
      )

      if (!selectedDate) {
        this.watchClinicAvailableTimes = []
        return
      }

      const selectedDateTimes = this.watchClinicTimeSlots.dates[
        selectedDate.value
      ]

      if (selectedDateTimes) {
        this.watchClinicAvailableTimes = selectedDateTimes.map(time => ({
          value: time,
          label: this.$t(time)
        }))
      }
    }
  },
  methods: {
    ...mapActions('cart', { addToCart: 'addItem' }),
    ...mapActions('cart', ['clear', 'updateQuantity']),
    ...mapActions('feedback', ['show']),
    ...mapActions('watch-memory', ['setValue']),
    openAccordion() {
      const imagesTabAccordion = this.$parent.$children.find(child => child.$el.id === 'images-tab-accordion')
      if (imagesTabAccordion) {
        imagesTabAccordion.open()
      }
    },
    getProductPrice: getProductPrice,
    getProductTitle() {
      if (this.item.productTitle) {
        return this.item.productTitle
      }

      return this.item.name
    },
    keyup(e) {
      if (e.keyCode === 27) {
        this.openWatches = false
      }
    },
    checkIfStrapHasStock() {
      return !!this.simpleProducts[STRAP_SIZE_KEY].find(
        strapSize => strapSize.stock.is_in_stock
      )
    },
    strapIsPreorder() {
      return !!this.simpleProducts[STRAP_SIZE_KEY].find(
        strapSize => strapSize.is_preorder
      )
    },
    convertBuckleMaterialImage(url) {
      return config.imageManager.product.protocol + '://' + config.imageManager.product.host + '/' + url
    },
    convertImage(url) {
      return config.magento2.imgUrl + url
    },
    compareSize(a, b) {
      if (a.strap_min_length < b.strap_min_length) {
        return -1
      }
      if (a.strap_min_length > b.strap_min_length) {
        return 1
      }
      return 0
    },
    watchClicked(product) {
      this.straps.dial = product
      this.setValue({ watch: product.sku })
    },
    async checkAndClearCart(type, sku) {
      const items = this.getCartItems
      let allowAdd = true
      let canSetQty = true
      let isUpdate = false
      if (items.length) {
        items.map(item => {
          if (
            type !== item.attribute_set_name &&
            (type === WATCH_CLINIC || item.attribute_set_name === WATCH_CLINIC)
          ) {
            // We clear the cart because we don't want experience and watches in the same cart
            this.clear()
          } else {
            if (type === WATCH_CLINIC) {
              // if the product if watch clinic we check wheter the experience already existe for an another date
              if (item.sku === sku) {
                if (
                  this.firstCustomOption &&
                  item.product_option &&
                  item.product_option.extension_attributes &&
                  item.product_option.extension_attributes.custom_options &&
                  item.product_option.extension_attributes.custom_options.length
                ) {
                  if (
                    item.product_option.extension_attributes.custom_options[0]
                      .option_value !==
                    this.firstCustomOption.option_value.toString()
                  ) {
                    // if experience doesn't exist we don't allow add
                    allowAdd = false
                  } else {
                    // Experience exists so we allow qty change
                    isUpdate = true
                    const fullQty = parseInt(item.qty) + parseInt(this.quantity)

                    if (fullQty <= this.maxExperiencesQty()) {
                      this.updateQuantity({
                        product: { ...item },
                        qty: fullQty
                      })
                    } else {
                      canSetQty = false
                    }
                  }
                }
              }
            }
          }
        })
      }
      return { allowAdd, canSetQty, isUpdate }
    },
    addToCartAndFeedback(product) {
      let ids = []

      let productToAdd

      if (product.attribute_set_name === WATCH_CLINIC) {
        const watchClinicProductMatch = this.getSelectedWatchClinicExperience()
        if (watchClinicProductMatch) {
          productToAdd = watchClinicProductMatch
        } else {
          productToAdd = product
        }
      } else {
        productToAdd = product
      }

      if (!this.firstCustomOption && this.item.product.bundle_options) {
        const currentProduct = this.item
        ids = this.item.product.bundle_options.map(bundleOption => {
          let id = null
          let sku = null
          let fullProduct = null
          const { option_id: optionId } = bundleOption
          const bundleStrap = bundleOption.product_links.find(({ sku }) =>
            this.simpleProducts[STRAP_SIZE_KEY] &&
            this.simpleProducts[STRAP_SIZE_KEY][this.strapSize]
              ? sku === this.simpleProducts[STRAP_SIZE_KEY][this.strapSize].sku
              : false
          )
          const bundleBuckle = bundleOption.product_links.find(({ sku }) =>
            this.simpleProducts[BUCKLE_KEY] &&
            this.simpleProducts[BUCKLE_KEY][this.buckleType]
              ? sku === this.simpleProducts[BUCKLE_KEY][this.buckleType].sku
              : false
          )

          if (bundleStrap) {
            id = bundleStrap.id
            sku = this.simpleProducts[STRAP_SIZE_KEY][this.strapSize].sku
            fullProduct = this.simpleProducts[STRAP_SIZE_KEY][this.strapSize]
            fullProduct.compatibleWatches = currentProduct.product.compatible_watches
          }
          if (bundleBuckle) {
            id = bundleBuckle.id
            sku = this.simpleProducts[BUCKLE_KEY][this.buckleType].sku
            fullProduct = this.simpleProducts[BUCKLE_KEY][this.buckleType]
          }
          return {
            optionId,
            id,
            sku,
            fullProduct
          }
        })
      }

      let payload

      if (this.item.product.attribute_set_name === WATCH_CLINIC) {
        const selectedWatchClinicExperience = this.getSelectedWatchClinicExperience()
        payload = {
          productToAdd: {
            ...productToAdd,
            sku: selectedWatchClinicExperience.sku,
            qty: this.quantity,
            extension_attributes: {
              calendar_time: {
                event_date: this.formatSelectedDate(),
                event_time: this.selectedEventTime,
                availability: this.quantity
              }
            },
            product_option: {
              extension_attributes: {
                custom_options: [this.firstCustomOption]
              }
            }
          }
        }
      } else {
        if (this.firstCustomOption && this.strapSize === null) {
          payload = {
            productToAdd: {
              ...productToAdd,
              product_option: {
                extension_attributes: {
                  custom_options: this.secondCustomOption
                    ? [this.firstCustomOption, this.secondCustomOption]
                    : [this.firstCustomOption]
                }
              },
              qty: this.quantity
            }
          }
        } else if (this.strapSize !== null) {
          payload = {
            productToAdd: {
              ...productToAdd,
              price:
                this.simpleProducts[STRAP_SIZE_KEY][this.strapSize].price +
                (this.buckleType !== null
                  ? this.simpleProducts[BUCKLE_KEY][this.buckleType].price
                  : 0),
              product_option: {
                extension_attributes: {
                  bundle_options: ids
                    .filter(({ id }) => id !== null)
                    .map(({ optionId, id, sku, fullProduct }) => {
                      return {
                        option_id: optionId,
                        option_qty: 1,
                        option_selections: [id],
                        // necessary to check stock status of the simple product of the bundle
                        extension_attributes: {
                          sku,
                          fullProduct
                        }
                      }
                    })
                }
              },
              buckleName:
                this.buckleType !== null
                  ? this.simpleProducts[BUCKLE_KEY][this.buckleType].name
                  : '',
              strapSize: this.simpleProducts[STRAP_SIZE_KEY][this.strapSize]
                .option_value_strap_size,
              sku: product.sku,
              id: product.id,
              image: product.thumbnail,
              name: product.name,
              qty: 1
            }
          }
        } else {
          payload = {
            productToAdd: {
              ...productToAdd
            }
          }
        }
      }

      if (product.apply_partial_payment === 1) {
        payload.productToAdd = {
          ...payload.productToAdd,
          extension_attributes: {
            ...(payload.productToAdd.custom_options &&
            payload.productToAdd.custom_options.extension_attributes
              ? payload.productToAdd.custom_options.extension_attributes
              : {}),
            partial_payment: {
              is_partial_payment: true,
              installment_number: 2
            }
          }
        }
      }

      this.checkAndClearCart(
        productToAdd.attribute_set_name,
        productToAdd.sku
      ).then(errors => {
        if (product.attribute_set_name === WATCH_CLINIC) {
          if (this.$v.$invalid) {
            this.$v.$touch()
          } else {
            if (errors.allowAdd) {
              if (!errors.isUpdate) {
                this.addToCart(payload).then(result => {
                  if (
                    result &&
                    result.serverResponses &&
                    result.serverResponses.length &&
                    result.serverResponses[0].status === 500
                  ) {
                    this.show({
                      message: result.serverResponses[0].result.result
                    })
                  } else {
                    if (
                      result &&
                      result.serverResponses &&
                      result.serverResponses[0] &&
                      result.serverResponses[0].result &&
                      result.serverResponses[0].result.resultCode === 500
                    ) {
                      throw new Error(result.serverResponses[0].result.result)
                    } else {
                      /* this.show({
                        message: this.$t(
                          'Your product has been added to your shopping bag'
                        )
                      }) */
                    }
                  }
                })
              } else {
                if (!errors.canSetQty) {
                  this.show({
                    message: this.$t(
                      `You cannot add more experiences in your cart, maximum quantity reached`
                    )
                  })
                }
              }
            } else {
              this.show({
                message: this.$t(
                  'Your product has not been added to your shopping bag. You cannot chose the same experience with 2 differents dates in the same cart. If you want to proceed please remove the previous experience.'
                )
              })
            }
          }
        } else {
          this.addToCart(payload)
            .then(result => {
              if (
                result &&
                result.serverResponses &&
                result.serverResponses[0] &&
                result.serverResponses[0].result &&
                result.serverResponses[0].result.resultCode === 500
              ) {
                throw new Error(result.serverResponses[0].result.result)
              } else {
                /* this.show({
                  message: this.$t(
                    'Your product has been added to your shopping bag'
                  )
                }) */
              }
            })
            .catch(error =>
              this.show({ message: this.$t(error), context: 'error' })
            )
        }
      })
    },
    slideTo(i) {
      this.$refs.carousel.slideTo(i)
      this.$refs.carousel.restartTimer()
    },
    updateProgress(payload) {
      this.currentSlide = payload.currentSlide
      this.updateArrows()
    },
    updateDials(payload) {
      this.currentDials = payload.currentSlide
    },
    progressAriaLabel(i) {
      return (i === 'undefined' && this.currentSlide === 0) ||
        (i && this.currentSlide === i + 1)
        ? this.$t('Slide') + ' ' + i + ' ' + this.$t('(current slide)')
        : this.$t('Slide') + ' ' + i
    },
    callGTM(event) {
      this.$gtm.trackEvent({
        event: event,
        products: [
          {
            name: this.item.product.name,
            id: this.item.product.sku,
            price: getProductPrice(this.item.product),
            brand: 'Zenith',
            category: 'Watches',
            productCase: this.item.product.option_value_material || '',
            productCaseSize: this.item.product.option_value_diameter || '',
            productColor: this.item.product.option_value_dial || '',
            productMasterId: this.item.product.collection || '',
            productSubCategory: this.item.product.option_value_line || '',
            productMidCategory: this.item.product.option_value_collection || '',
            productPowerReserve:
              this.item.product.option_value_power_reserve || '',
            productStock:
              this.item.product.stock && this.item.product.stock.is_in_stock
                ? 'In stock'
                : 'Out of stock',
            productStrap: this.item.product.option_value_bracelet || '',
            productWaterResistance:
              this.item.product.option_value_water_resistance || ''
          }
        ]
      })
    },
    enterSlider(event) {
      if (this.$refs.prevButton.classList.contains('hidden-button')) {
        this.$refs.prevButton.classList.remove('hidden-button')
        this.$refs.nextButton.classList.remove('hidden-button')
        this.updateArrows()
      }
    },
    leaveSlider(event) {
      if (!event.relatedTarget || !event.relatedTarget.contains(event.target)) {
        this.$refs.prevButton.classList.add('hidden-button')
        this.$refs.nextButton.classList.add('hidden-button')
      }
    },
    updateArrows() {
      if (this.currentSlide % this.pictures.length === 0) {
        this.$refs.prevButton.classList.add('black-arrow')
        this.$refs.nextButton.classList.add('black-arrow')
      } else {
        if (this.$refs.prevButton.classList.contains('black-arrow')) {
          this.$refs.prevButton.classList.remove('black-arrow')
          this.$refs.nextButton.classList.remove('black-arrow')
        }
      }
    },
    startProgressBar() {
      // hack for progress bar
      if (this.$refs.buttons) {
        this.$refs.buttons.map(button => {
          if (button.classList.contains('-not-started'))
            button.classList.remove('-not-started')
        })
        this.loop = 1
      }
    },
    canLoadSlide(indx) {
      if (this.loadedSlides.includes(indx)) {
        return true
      }
      let tmpCurrentSlide = this.currentSlide

      if (this.currentSlide < 0) {
        // is infinite slide and the user is scrolling back in the previous sides
        tmpCurrentSlide = -Math.abs(
          this.pictures.length - Math.abs(this.currentSlide)
        )
      }

      const diff = Math.abs(Math.abs(tmpCurrentSlide) - indx)

      // Load only the first slide in the server to avoid paralle download during the page load
      // Eager lazy attribute will be used to prevent browser lazy loading and use only in JS lazy load
      if (
        (isServer && diff === 0) ||
        (!isServer && (diff <= 1 || diff === 0))
      ) {
        this.loadedSlides = [...this.loadedSlides, indx]
        return true
      }

      return false
    },
    alertAvailability() {
      this.availableModal = true
    },
    alertIcons() {
      this.iconsModal = true
    },
    onScroll() {
      if (this.pictures.length > 1) {
        if (
          this.$refs['picture-desktop'] &&
          this.$refs['picture-desktop'].getBoundingClientRect().top <= 0
        ) {
          this.isSticky = true
          const pictureDesktop: HTMLElement = this.$refs['picture-desktop']

          if (
            window.scrollY + this.$refs['detail'].clientHeight >
            pictureDesktop.getBoundingClientRect().top +
              window.scrollY +
              pictureDesktop.clientHeight
          ) {
            this.isBottom = true
            this.isSticky = false
          } else {
            this.isBottom = false
          }
        } else {
          this.isSticky = false
          this.isBottom = false
        }
      }
    },
    getConcatImage(left, right, printPath = true) {
      let url =
        left.replace('.png', '') +
        '_' +
        right.replace('/', '.').toLowerCase() +
        '.png'
      return printPath ? this.convertImage(url) : url
    },
    getStrapWithBuckleImage(strap, buckle, printPath = true) {
      let url = strap.soldat.src
      let imagesArray = strap.product.strap_with_buckles_images
      if (imagesArray) {
        let image = imagesArray.find(
          image => (image.image.includes(buckle) || image.image.includes(buckle.replaceAll('.', '-')))
        )
        if (image) {
          url = image.image
        }
      }
      return printPath ? this.convertImage(url) : url
    },
    checkForStrap() {
      // here check
      if (!this.item.product.main_category) {
        return
      }

      const toFind = 'Straps'
      const filtered = this.item.product.main_category.filter(el => {
        return el.name === toFind
      })
      if (filtered.length > 0) {
        this.straps = {
          dial: {},
          dials: []
        }
        this.straps.dials = this.item.product.related_products
          .filter(product => !!product.dial_image)
          .map(product => ({
            sku: product.sku,
            cadran: product.dial_image
              ? this.convertImage(product.dial_image)
              : null,
            src: this.getConcatImage(product.image, this.item.product.sku),
            alt: product.name,
            soldat: true,
            width: '',
            height: ''
          }))
        this.straps.dial = this.straps.dials.find(
          element => element.sku === this.getWatch
        )
        if (!this.straps.dial) {
          this.straps.dial = this.straps.dials[0]
        }
      }
    },
    scrollTo(id) {
      window.scrollTo({
        top: document.querySelector(id).offsetTop - 200,
        behavior: 'smooth'
      })
    },
    setWatchClinicAvailableDates() {
      getWatchClinicDates({
        itemId: this.selectedWatchClinicExperience,
        month: this.selectedMonth
      }).then(res => {
        const dates = {}
        const availabilities = {}
        const languages = {}
        for (const date of res) {
          if (dates.hasOwnProperty(date.event_date)) {
            dates[date.event_date].push(date.event_time)
          } else {
            dates[date.event_date] = [date.event_time]
          }

          const availabilityKey = `${date.event_date}-${date.event_time}`
          availabilities[availabilityKey] = date.availability
          languages[availabilityKey] = date.language
        }

        this.watchClinicTimeSlots = {
          dates,
          availabilities,
          languages
        }

        this.watchClinicAvailableDates = Object.keys(dates).map(key => ({
          label: key,
          value: key
        }))
      })
    },
    getIsAddToCartEnabled() {
      if (this.item.product.attribute_set_name !== WATCH_CLINIC) {
        return this.firstCustomOptionsOptions.length > 0
      }

      return !!this.watchClinicAvailableDates.length
    },
    maxExperiencesQty() {
      if (this.item.product.attribute_set_name === WATCH_CLINIC) {
        if (this.selectedEventDate != null && this.selectedEventTime != null) {
          let date = this.formatSelectedDate()
          const availabilityKey = `${date}-${this.selectedEventTime}`

          if (
            this.watchClinicTimeSlots.availabilities &&
            this.watchClinicTimeSlots.availabilities[availabilityKey]
          ) {
            return this.watchClinicTimeSlots.availabilities[availabilityKey]
          }

          return 0
        }
      }

      return this.item.product.stock.max_sale_qty
    },
    getSelectedWatchClinicExperience() {
      if (!this || !this.selectedWatchClinicExperience) {
        return null
      }
      const watchClinicProductMatch = this.watchClinicExperiences.find(
        experience =>
          experience.value.toString() ===
          this.selectedWatchClinicExperience.toString()
      )

      if (watchClinicProductMatch) {
        return watchClinicProductMatch.product
      } else {
        return null
      }
    },
    getCustomOptions() {
      let customOptions = []

      if (this.item.product.attribute_set_name === WATCH_CLINIC) {
        let watchClinic = this.getSelectedWatchClinicExperience()
        if (watchClinic) {
          let date = this.formatSelectedDate()
          const availabilityKey = `${date}-${this.selectedEventTime}`
          customOptions = this.watchClinicTimeSlots.languages[availabilityKey]
        } else {
          customOptions = this.item.product.custom_options
        }
      } else {
        customOptions = this.item.product.custom_options
      }

      return customOptions || []
    },
    formatSelectedDate() {
      if (this.selectedEventDate) {
        return moment(this.selectedEventDate).format('YYYY-MM-DD')
      }

      return null
    },
    handleMonthChange(e) {
      this.selectedMonth = {y: e.getFullYear(), m: e.getMonth()}
      this.setWatchClinicAvailableDates()
    },
    openProductZoomGallery(indx) {
      this.productZoomGalleryIndex = indx
      this.productZoomGalleryOpen = true
    },
    openInquireByEmail() {
      this.inquireOverlayVisible = true
    },
    closeInquireByEmail() {
      this.inquireOverlayVisible = false
    },
    openAppointmentVisible() {
      this.appointmentVisible = true
    },
    closeAppointmentVisible() {
      this.appointmentVisible = false
    }
  },
  mounted() {
    // this.$el.querySelector('button, a').focus()
    window.addEventListener('scroll', this.onScroll)
    this.callGTM('eeProductDetail')
    this.startProgressBar()
    document.addEventListener('keyup', this.keyup)
    this.hasStrapSlider = !!document.getElementById('additional_straps')
  },
  created() {
    // to morve start
    const skus =
      this.item.product && this.item.product.bundle_options
        ? this.item.product.bundle_options
            .map(bundle => bundle.product_links.map(link => link.sku))
            .reduce((acc, curr) => [...acc, ...curr])
        : []

    const storeView = currentStoreView()
    const productQuery = ({ skus }) => {
      let query = new SearchQuery().applyFilter({
        key: 'sku',
        value: { in: skus }
      })
      // .applyFilter({ key: 'visibility', value: { in: [2, 3, 4] } })
      // .applyFilter({ key: 'status', value: { in: [1] } })
      return query
    }
    // const attributeQuery = () => {
    //   let query = new SearchQuery()
    //   return query
    // }
    
    quickSearchByQuery({
      query: {query: {bool: {filter: {bool: {must: [{terms: {id: [this.item.product.category[0].category_id]}}]}}}}},
      entityType: 'category',
      storeCode: storeView.storeCode,
      start: 0,
      size: 100
    }).then((result) => {
      if (result.items && result.items[0]) {
        const parentCategoriesData = result.items[0].parents_data
        const lastCategoryData = parentCategoriesData[parentCategoriesData.length - 1]
        this.breadCrumbItems = [
          { name: lastCategoryData.name, url_key: lastCategoryData.id },
          { name: this.item.product.name }]
      }
    })

    let query: SearchQuery = new SearchQuery()
    query = query.applyFilter({
      key: 'sku',
      value: { in: this.item.product.watch_clinic_experiences || [] }
    })

    // get products with attribute set Watch Clinic

    if (this.item.product.attribute_set_name === WATCH_CLINIC) {
      quickSearchByQuery({
        query: query,
        entityType: 'product',
        storeCode: storeView.storeCode,
        start: 0,
        size: 100
      })
        .then(({ items }) => items)
        .then(items => {
          this.watchClinicExperiences = items.map(item => {
            return {
              value: item.id,
              sku: item.sku,
              label: item.name,
              product: item
            }
          })
        })
    }

    quickSearchByQuery({
      query: productQuery({ skus }),
      entityType: 'product',
      storeCode: storeView.storeCode,
      start: 0,
      size: 100
    })
      .then(({ items }) => items)
      .then(items => {
        return items.reduce((acc, curr) => {
          if (!acc[curr['attribute_set_id']]) acc[curr['attribute_set_id']] = []
          acc[curr['attribute_set_id']].push(curr)
          return acc
        }, {})
      })
      .then(groups => {
        this.simpleProducts =
          groups && groups[STRAP_SIZE_KEY] && groups[BUCKLE_KEY]
            ? groups
            : this.simpleProducts
        this.simpleProducts[STRAP_SIZE_KEY] = this.simpleProducts[
          STRAP_SIZE_KEY
        ].sort(this.compareSize)
        this.strapSize = groups[STRAP_SIZE_KEY]
          ? groups[STRAP_SIZE_KEY].findIndex(
              strap =>
                strap.option_value_strap_size === 'Standard' &&
                strap.stock &&
                strap.stock.is_in_stock
            )
          : null
        this.strapSize = this.strapSize === -1 ? null : this.strapSize
      })
    // .then((products) => {
    //   return quickSearchByQuery({ query: attributeQuery(), entityType: 'attribute', storeCode: storeView.storeCode, start: 0, size: 1000 })
    //     .then(({ items }) => items)
    //     .then((items) => items.map(({ attribute_code, attribute_id }) => ({ attribute_code, attribute_id })))
    //     .then((attributes) => {
    //       return products.map((item) => {
    //         const attribute = attributes.find((attr) => attr.attribute_id === item.attribute_set_id)
    //         item.attribute_code = attribute.attribute_code
    //         return item
    //       })
    //     })
    // })
    // to move end

    this.$ready()
    this.i18n = currentStoreView().i18n
    this.ecommerceActivated = this.$store.state['zenith-ui'].ecommerce
    this.checkForStrap()
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.onScroll)
    document.removeEventListener('keyup', this.keyup)
  }
})
